import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import mergeWith from 'lodash/mergeWith';
import classnames from 'classnames';
/**
 * RCE merge will skip customisations that are not in the base
 * this means you need to fill the base with empty rules. I didn't
 * like that so this adds missing keys into the base before the merge.
 *
 * @param base
 * @param custom
 */ export default function mergeTheme(base, custom) {
    return mergeWith(_object_spread({}, base), custom || {}, (defaultStyleClassName, themeClassName)=>classnames(defaultStyleClassName, themeClassName));
}
